var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"links"},_vm._l((_vm.menuJP.MenuList),function(link,index){return _c('li',{key:index,class:{ selected: _vm.checkSelect(link.PageJson) }},[_c('router-link',{attrs:{"tag":"a","to":{ name: 'Japanese', params: { page: link.PageJson } }}},[_vm._v(_vm._s(link.MenuTitle))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }